import { render, staticRenderFns } from "./IconoCompartido.vue?vue&type=template&id=92d6a696&"
import script from "./IconoCompartido.vue?vue&type=script&lang=js&"
export * from "./IconoCompartido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports